import { env } from '.'
import labels from './i18n/labels'

const getLabel = key => {
  const lang = env('REACT_APP_LANG')
  return labels?.[lang]?.[key]
}

export default getLabel
